import React, { useState, useEffect, useMemo } from "react";
import {
  Box, Grid, TextField, Button, MenuItem, Snackbar, Alert, Typography, CircularProgress, Chip, Divider, IconButton, ListItemText, Select, InputLabel, FormControl, OutlinedInput,
} from "@mui/material";
import DatePicker from "react-multi-date-picker";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { API_URL } from "../../../Config/api";

const genders = [
  { value: "0", label: "No Preference" },
  { value: "1", label: "Male" },
  { value: "2", label: "Female" },
];

const schedules = [
  { value: "1", label: "Service" },
  { value: "2", label: "Session" },
];

const PackageReschedule = ({
  eventID,
  accessToken,
  onClose,
  rowData,
  fetchPackages,
}) => {
  const navigate = useNavigate();
  console.log(eventID, "eventIDeventIDeventIDeventID for reschedule")
  const [selectedOption, setSelectedOption] = useState("");
  const [consultantId, setConsultantId] = useState("0");

  // Form fields for main Package Service
  const [values, setValues] = useState([]);
  const [remark, setRemark] = useState("");

  // States to store individual sub-service dates and timings
  const [serviceDates, setServiceDates] = useState({});
  const [serviceStartTimes, setServiceStartTimes] = useState({});
  const [serviceEndTimes, setServiceEndTimes] = useState({});

  ////seleectd session dates
  // const [selectedSessionDates, setSelectedSessionDates] = useState("");
  const [sessionRows, setSessionRows] = useState([]);

  //// time session
  const [showSessionTime, setShowSessionTime] = useState({});
  const [sessionServiceTimes, setSessionServiceTimes] = useState({});

  const [sessionRescheduleData, setSessionRescheduleData] = useState({
    from_date: [],
    to_date: [],
  });
  // Form fields for Session
  const [sessionDate, setSessionDate] = useState("");
  const [selectedServiceKey, setSelectedServiceKey] = useState(""); // Holds the chosen date/service combo

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  // API Data States
  const [fetchedServiceData, setFetchedServiceData] = useState(null);
  const [fetchedSessionData, setFetchedSessionData] = useState({});
  const [isLoadingApi, setIsLoadingApi] = useState(false);

  const currentDateString = new Date().toISOString().split("T")[0];

  // Convert main selected package dates into a flat array of "YYYY-MM-DD"
  const flatPackageDates = useMemo(() => {
    const flatList = [];
    (values || []).forEach((item) => {
      if (Array.isArray(item) && item.length === 2) {
        let start = new Date(item[0].toDate());
        let end = new Date(item[1].toDate());
        let current = new Date(start);
        while (current <= end) {
          const y = current.getFullYear();
          const m = String(current.getMonth() + 1).padStart(2, "0");
          const d = String(current.getDate()).padStart(2, "0");
          flatList.push(`${y}-${m}-${d}`);
          current.setDate(current.getDate() + 1);
        }
      } else if (item) {
        let dObj = Array.isArray(item) ? item[0] : item;
        if (dObj && dObj.format) {
          flatList.push(dObj.format("YYYY-MM-DD"));
        }
      }
    });
    return [...new Set(flatList)];
  }, [values]);

  const handleDateChange = (newValues) => {
    setValues(newValues || []);
    setServiceDates({}); // Reset individual service dates when main dates change
  };

  // Auto-calculate End Time Logic
  const handleServiceTimeChange = (idx, field, value, subServiceName = "") => {
    if (field === "start") {
      setServiceStartTimes((prev) => ({ ...prev, [idx]: value }));

      if (value) {
        let hoursToAdd = 1;

        // Smart parse: Check if service name contains words like "4 Hours", "12 Hours"
        const match = subServiceName.match(/(\d+)\s*Hour/i);
        if (match) {
          hoursToAdd = parseInt(match[1], 10);
        }

        const [hh, mm] = value.split(":");
        let dateObj = new Date();
        dateObj.setHours(parseInt(hh, 10));
        dateObj.setMinutes(parseInt(mm, 10));

        dateObj.setHours(dateObj.getHours() + hoursToAdd);

        const endH = String(dateObj.getHours()).padStart(2, "0");
        const endM = String(dateObj.getMinutes()).padStart(2, "0");

        setServiceEndTimes((prev) => ({ ...prev, [idx]: `${endH}:${endM}` }));
      }
    } else {
      setServiceEndTimes((prev) => ({ ...prev, [idx]: value }));
    }
  };

  const mapServiceDays = ({ date }) => {
    const dateStr = date.format("YYYY-MM-DD");
    if (!flatPackageDates.includes(dateStr)) {
      return {
        disabled: true,
        style: {
          color: "#ccc",
          backgroundColor: "#f5f5f5",
          cursor: "not-allowed",
        },
      };
    }
    return {
      style: { backgroundColor: "#e0f2f1", color: "#000", fontWeight: "bold" },
    };
  };

  useEffect(() => {
    if (!selectedOption) return;

    const fetchRescheduleDetails = async () => {
      setIsLoadingApi(true);
      try {
        const response = await fetch(
          `${API_URL}/packages/DayRescheduleFetch/${eventID}/${selectedOption}/`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          },
        );
        const data = await response.json();

        if (selectedOption === "1") {
          setFetchedServiceData(data.message);
        }
        else if (selectedOption === "2") {
          setFetchedSessionData(data.message || {});
        }
      } catch (error) {
        console.error("Error fetching reschedule details:", error);
        showSnackbar("Failed to fetch schedule details from server", "error");
      } finally {
        setIsLoadingApi(false);
      }
    };

    fetchRescheduleDetails();
  }, [selectedOption, eventID, accessToken]);

  // --------------------------------------------------------
  // Submit Handler for SERVICE
  // --------------------------------------------------------

  const buildSelectedDateRanges = (dates) => {
    const sortedDates = (dates || [])
      .map((date) => date.format("YYYY-MM-DD"))
      .sort();

    if (!sortedDates.length) {
      return [];
    }

    const ranges = [];

    let startDate = sortedDates[0];
    let endDate = sortedDates[0];

    for (let i = 1; i < sortedDates.length; i++) {
      const previousDate = new Date(endDate);
      const currentDate = new Date(sortedDates[i]);

      previousDate.setDate(previousDate.getDate() + 1);

      if (previousDate.getTime() === currentDate.getTime()) {
        endDate = sortedDates[i];
      } else {
        ranges.push([startDate, endDate]);

        startDate = sortedDates[i];
        endDate = sortedDates[i];
      }
    }

    ranges.push([startDate, endDate]);

    return ranges;
  };


  const handleServiceSubmit = async () => {
    try {
      if (!values || values.length === 0) {
        showSnackbar("Please select package dates", "error");
        return;
      }

      if (!remark.trim()) {
        showSnackbar("Please enter remark", "error");
        return;
      }

      const services = fetchedServiceData?.service_details || [];

      if (services.length === 0) {
        showSnackbar("No service details found", "error");
        return;
      }

      // Validate package duration
      if (
        fetchedServiceData?.duration &&
        flatPackageDates.length !== fetchedServiceData.duration
      ) {
        showSnackbar(
          `Please select exactly ${fetchedServiceData.duration} package dates`,
          "error"
        );
        return;
      }

      // Validate each service
      for (let idx = 0; idx < services.length; idx++) {
        const service = services[idx];

        if (!service.poc_id) {
          showSnackbar(
            `Event Plan Of Care is missing for ${service.service_name}`,
            "error"
          );
          return;
        }

        const selectedDates = serviceDates[idx] || [];

        if (selectedDates.length === 0) {
          showSnackbar(
            `Please select dates for ${service.service_name}`,
            "error"
          );
          return;
        }

        if (!serviceStartTimes[idx]) {
          showSnackbar(
            `Please select start time for ${service.service_name}`,
            "error"
          );
          return;
        }

        if (!serviceEndTimes[idx]) {
          showSnackbar(
            `Please select end time for ${service.service_name}`,
            "error"
          );
          return;
        }
      }

      // Main request body
      const requestData = {
        PackageDates: flatPackageDates,
        Remark: remark.trim(),
      };

      // Add service-wise data using poc_id as dynamic key
      services.forEach((service, idx) => {
        const selectedDates = serviceDates[idx] || [];

        requestData[service.poc_id] = {
          SelectedDates: buildSelectedDateRanges(selectedDates),
          StartTime: serviceStartTimes[idx],
          EndtTime: serviceEndTimes[idx],
          Consultant_preferred: parseInt(consultantId, 10),
        };
      });

      console.log(
        "Final Service Reschedule Payload:",
        JSON.stringify(requestData, null, 2)
      );

      setIsLoadingApi(true);

      const response = await fetch(
        `${API_URL}/packages/Service_reschedule/${eventID}/`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data?.message ||
          data?.error ||
          "Failed to reschedule service"
        );
      }

      showSnackbar(
        data?.message || "Service rescheduled successfully",
        "success"
      );

      setTimeout(() => {
        onClose();
        navigate("/service-request");
      }, 1500);
      console.log("Service reschedule response:", data);
    } catch (error) {
      console.error("Service reschedule error:", error);

      showSnackbar(
        error.message || "Something went wrong while rescheduling",
        "error"
      );
    } finally {
      setIsLoadingApi(false);
    }
  };

  // const handleServiceSubmit = async (event) => {
  //   event.preventDefault();

  //   if (values.length === 0 || !remark) {
  //     showSnackbar(
  //       "Please fill all required package details and remark.",
  //       "error",
  //     );
  //     return;
  //   }

  //   if (flatPackageDates.length !== fetchedServiceData.duration) {
  //     showSnackbar(
  //       `Please select exactly ${fetchedServiceData.duration} days for the package overall. You selected ${flatPackageDates.length} days.`,
  //       "error",
  //     );
  //     return;
  //   }

  //   const services = fetchedServiceData.service_details || [];
  //   for (let i = 0; i < services.length; i++) {
  //     const srv = services[i];
  //     const selectedForSrv = serviceDates[i] || [];

  //     if (selectedForSrv.length !== srv.duration) {
  //       showSnackbar(
  //         `Please select exactly ${srv.duration} dates for ${srv.service_name}.`,
  //         "error",
  //       );
  //       return;
  //     }

  //     if (!serviceStartTimes[i] || !serviceEndTimes[i]) {
  //       showSnackbar(
  //         `Please select Start Time and End Time for ${srv.service_name}.`,
  //         "error",
  //       );
  //       return;
  //     }
  //   }

  //   const individualServiceDates = services.map((srv, idx) => {
  //     return {
  //       service_id: srv.service,
  //       sub_service_id: srv.sub_service,
  //       dates_selected: (serviceDates[idx] || []).map((d) =>
  //         d.format("YYYY-MM-DD"),
  //       ),
  //       start_time: serviceStartTimes[idx],
  //       end_time: serviceEndTimes[idx],
  //     };
  //   });

  //   // const requestData = {
  //   //   [eventID]: {
  //   //     SelectedDates: flatPackageDates,
  //   //     StartTime: "",
  //   //     EndtTime: "",
  //   //     Consultant_preferred: parseInt(consultantId),
  //   //     Remark: remark,
  //   //     ServiceWiseAllocations: individualServiceDates,
  //   //   },
  //   // };
  //   const requestData = {
  //     [eventID]: {
  //       SelectedDates: flatPackageDates,
  //       StartTime: "",
  //       EndtTime: "",
  //       Consultant_preferred: parseInt(consultantId),
  //       // ServiceWiseAllocations: individualServiceDates,
  //     },
  //     Remark: remark,
  //     PackageDates: flatPackageDates
  //   };

  //   try {
  //     const response = await fetch(
  //       `${API_URL}/packages/Service_reschedule/${eventID}/`,
  //       {
  //         method: "POST",
  //         headers: {
  //           Authorization: `Bearer ${accessToken}`,
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(requestData),
  //       },
  //     );
  //     if (response.ok) {
  //       showSnackbar(
  //         "Service rescheduled successfully! Redirecting...",
  //         "success",
  //       );
  //       setTimeout(() => {
  //         onClose();
  //         navigate("/service-request");
  //       }, 1500);
  //     } else {
  //       showSnackbar("Failed to reschedule service.", "error");
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     showSnackbar("An error occurred.", "error");
  //   }
  // };


  const handleSessionSubmit = (event) => {
    event.preventDefault();

    // 1. Check if at least one session row is added
    if (sessionRows.length === 0) {
      showSnackbar("Please add a session to reschedule.", "error");
      return;
    }

    // 2. Check if every row has both dates
    const hasMissingDate = sessionRows.some(
      (row) => !row.sessionDate || !row.newSessionDate
    );

    if (hasMissingDate) {
      showSnackbar(
        "Please select Session Date and New Session Date for all sessions.",
        "error"
      );
      return;
    }

    // 3. Get all From dates
    const fromDates = sessionRows.map((row) => row.sessionDate);

    // 4. Get all New/To dates
    const toDates = sessionRows.map((row) => row.newSessionDate);

    // 5. Prevent duplicate NEW session dates between rows
    const hasDuplicateNewDates =
      toDates.length !== new Set(toDates).size;

    if (hasDuplicateNewDates) {
      showSnackbar(
        "The same new session date cannot be selected for multiple sessions. Please select another date.",
        "error"
      );
      return;
    }

    // 6. Prevent NEW session date from being an existing session date
    const hasExistingSessionDateSelected = toDates.some((newDate) =>
      availableSessionDates.some(
        (existingDate) =>
          existingDate.substring(0, 10) === newDate
      )
    );

    // if (hasExistingSessionDateSelected) {
    //   showSnackbar(
    //     "This date is already scheduled. Please select another date.",
    //     "error"
    //   );
    //   return;
    // }

    for (const row of sessionRows) {
      const services = fetchedSessionData[row.sessionDate] || [];

      for (let serviceIndex = 0; serviceIndex < services.length; serviceIndex++) {
        const timeKey = `${row.id}-${serviceIndex}`;
        const serviceTime = sessionServiceTimes[timeKey] || {};

        if (serviceTime.startTime && !serviceTime.endTime) {
          showSnackbar(
            `Please select End Time also for ${services[serviceIndex].sub_service_name}.`,
            "error"
          );
          return;
        }

        if (!serviceTime.startTime && serviceTime.endTime) {
          showSnackbar(
            `Please select Start Time also for ${services[serviceIndex].sub_service_name}.`,
            "error"
          );
          return;
        }
      }
    }

    // const subServices = sessionRows.flatMap((row) => {
    //   const services = fetchedSessionData[row.sessionDate] || [];

    //   return services.map((srv) => ({
    //     sub_service_id: srv.service_name,
    //     sub_service_name: srv.sub_service_name,
    //     start_time: srv.start_time,
    //     end_time: srv.end_time,
    //   }));
    // });

    const subServices = sessionRows.flatMap((row) => {
      const services = fetchedSessionData[row.sessionDate] || [];

      return services.map((srv, serviceIndex) => {
        const timeKey = `${row.id}-${serviceIndex}`;
        const selectedTime = sessionServiceTimes[timeKey] || {};

        return {
          sub_service_id: srv.service_name,
          sub_service_name: srv.sub_service_name,

          // Pass the time selected/changed by the user
          start_time: selectedTime.startTime || "",
          end_time: selectedTime.endTime || "",
        };
      });
    });


    const requestData = {
      from_date: fromDates,
      to_date: toDates,
      flag: 3,
      eve_id: eventID,
      isPackage: true,
      sub_services: subServices,
    };

    // 8. Store and navigate
    setSessionRescheduleData(requestData);

    console.log("Session Reschedule Data:", requestData);

    navigate("/viewservice", {
      state: {
        sessionRescheduleData: requestData,
      },
    });
  };


  const showSnackbar = (msg, severity) => {
    setSnackbarMessage(msg);
    setSnackbarSeverity(severity);
    setOpenSnackbar(true);
  };

  const availableSessionDates = Object.keys(fetchedSessionData);
  const selectedSessionDates = sessionRows
    .map((row) => row.sessionDate)
    .filter(Boolean);

  const isAllSessionDatesSelected =
    availableSessionDates.length > 0 &&
    selectedSessionDates.length >= availableSessionDates.length;

  const addSessionRow = () => {
    setSessionRows((prev) => [
      ...prev,
      {
        id: Date.now(),
        sessionDate: "",
        newSessionDate: "",
        selectedServiceKey: "",
      },
    ]);
  };

  const removeSessionRow = (rowId) => {
    setSessionRows((prev) => prev.filter((row) => row.id !== rowId));
  };

  const updateSessionRow = (rowId, field, value) => {
    setSessionRows((prev) =>
      prev.map((row) =>
        row.id === rowId
          ? {
            ...row,
            [field]: value,
            ...(field === "sessionDate"
              ? { selectedServiceKey: "" }
              : {}),
          }
          : row,
      ),
    );
  };

  const handleSessionTimeChange = (rowId, serviceIndex, field, value) => {
    const key = `${rowId}-${serviceIndex}`;

    setSessionServiceTimes((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        [field]: value,
      },
    }));
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        maxHeight: "75vh",
        width: { xs: "100%", sm: 550, md: 600 },
      }}
    >
      <Box
        sx={{
          flexGrow: 1,
          overflowY: "auto",
          px: 1,
          pb: 2,
          "&::-webkit-scrollbar": { width: "6px" },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "#f1f1f1",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#c1c1c1",
            borderRadius: "10px",
          },
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sx={{ mt: 1 }}>
            <TextField
              select
              label="Schedule Type"
              value={selectedOption}
              onChange={(e) => setSelectedOption(e.target.value)}
              size="small"
              fullWidth
            >
              {schedules.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          {isLoadingApi && (
            <Grid
              item
              xs={12}
              sx={{ display: "flex", justifyContent: "center", py: 4 }}
            >
              <CircularProgress size={30} sx={{ color: "rgb(52, 123, 137)" }} />
            </Grid>
          )}

          {/* ---------------- FIELDS FOR SERVICE (Type 1) ---------------- */}
          {selectedOption === "1" && !isLoadingApi && (
            <>
              {fetchedServiceData && (
                <Grid item xs={12}>
                  <Box
                    sx={{
                      p: 2,
                      bgcolor: "#f0f7f9",
                      borderRadius: "10px",
                      border: "1px solid #d4e8ea",
                    }}
                  >
                    <Typography
                      variant="subtitle1"
                      sx={{ fontWeight: 700, color: "#245863" }}
                    >
                      Package: {fetchedServiceData.package_name}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ mt: 0.5, color: "#4f7b85", fontWeight: 500 }}
                    >
                      Total Package Duration: {fetchedServiceData.duration} days
                    </Typography>
                  </Box>
                </Grid>
              )}

              <Grid item xs={12}>
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 600, mb: 1, color: "#444" }}
                >
                  1. Select Overall Package Dates
                </Typography>
                <DatePicker
                  multiple
                  range
                  value={values}
                  onChange={handleDateChange}
                  minDate={currentDateString}
                  containerStyle={{ width: "100%" }}
                  render={(value, openCalendar) => (
                    <TextField
                      onClick={openCalendar}
                      label={`Package Dates (${fetchedServiceData?.duration || "N/A"} Days) *`}
                      value={value}
                      size="small"
                      fullWidth
                      error={
                        values.length > 0 &&
                        flatPackageDates.length !== fetchedServiceData?.duration
                      }
                      helperText={
                        values.length > 0 &&
                          flatPackageDates.length !== fetchedServiceData?.duration
                          ? `Selected ${flatPackageDates.length} days. Needs to be exactly ${fetchedServiceData?.duration} days.`
                          : ""
                      }
                    />
                  )}
                />
              </Grid>

              {fetchedServiceData?.service_details &&
                fetchedServiceData.service_details.length > 0 && (
                  <Grid item xs={12}>
                    <Divider sx={{ my: 1 }} />
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600, mb: 2, color: "#444" }}
                    >
                      2. Allocate Dates & Timings for Individual Services
                    </Typography>

                    <Box sx={{ pl: 1, borderLeft: "3px solid #ccc" }}>
                      {fetchedServiceData.service_details.map((srv, idx) => (
                        <Box key={idx} sx={{ mb: 3.5 }}>
                          <Typography
                            variant="body2"
                            sx={{ fontWeight: 600, mb: 0.5, color: "#333" }}
                          >
                            • {srv.service_name}{" "}
                            <span style={{ fontWeight: 400, color: "#666" }}>
                              ({srv.sub_service_name})
                            </span>
                          </Typography>
                          <Typography
                            variant="caption"
                            sx={{
                              display: "block",
                              mb: 1.5,
                              color: "#d32f2f",
                              fontWeight: 500,
                            }}
                          >
                            * Required Days: {srv.duration}
                          </Typography>

                          <Grid container spacing={1.5}>
                            <Grid item xs={12}>
                              <DatePicker
                                multiple
                                value={serviceDates[idx] || []}
                                onChange={(val) =>
                                  setServiceDates((prev) => ({
                                    ...prev,
                                    [idx]: val,
                                  }))
                                }
                                mapDays={mapServiceDays}
                                minDate={currentDateString}
                                containerStyle={{ width: "100%" }}
                                render={(value, openCalendar) => (
                                  <TextField
                                    onClick={openCalendar}
                                    label={`Select Dates`}
                                    value={value}
                                    size="small"
                                    fullWidth
                                    disabled={flatPackageDates.length === 0}
                                    placeholder={
                                      flatPackageDates.length === 0
                                        ? "First select overall package dates above"
                                        : `Select exactly ${srv.duration} dates`
                                    }
                                    error={
                                      serviceDates[idx] &&
                                      serviceDates[idx].length !== srv.duration
                                    }
                                  />
                                )}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <TextField
                                label="Start Time"
                                type="time"
                                value={serviceStartTimes[idx] || ""}
                                onChange={(e) =>
                                  handleServiceTimeChange(
                                    idx,
                                    "start",
                                    e.target.value,
                                    srv.sub_service_name,
                                  )
                                }
                                size="small"
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <TextField
                                label="End Time"
                                type="time"
                                value={serviceEndTimes[idx] || ""}
                                onChange={(e) =>
                                  handleServiceTimeChange(
                                    idx,
                                    "end",
                                    e.target.value,
                                  )
                                }
                                size="small"
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                              />
                            </Grid>
                          </Grid>
                        </Box>
                      ))}
                    </Box>
                    <Divider sx={{ my: 1 }} />
                  </Grid>
                )}

              <Grid item xs={12}>
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 600, mb: 1, color: "#444" }}
                >
                  3. Additional Preferences
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  select
                  label="Consultant Preferred"
                  value={consultantId}
                  onChange={(e) => setConsultantId(e.target.value)}
                  size="small"
                  fullWidth
                >
                  {genders.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Remark"
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                  size="small"
                  fullWidth
                  multiline
                  rows={2}
                />
              </Grid>
            </>
          )}

          {selectedOption === "2" && !isLoadingApi && (
            <>
              {availableSessionDates.length > 0 && (
                <Grid item xs={12}>
                  <Box
                    sx={{
                      p: 2,
                      bgcolor: "#f8f9fa",
                      borderRadius: "10px",
                      border: "1px solid #eee",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        mb: sessionRows.length > 0 ? 1.5 : 0,
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: 600,
                          color: "#333",
                        }}
                      >
                        Current Scheduled Package Dates:
                      </Typography>

                      <IconButton
                        size="small"
                        onClick={addSessionRow}
                        disabled={isAllSessionDatesSelected}
                        sx={{
                          backgroundColor: isAllSessionDatesSelected
                            ? "#eeeeee"
                            : "#e0f2f1",
                          color: isAllSessionDatesSelected
                            ? "#aaaaaa"
                            : "#347b89",
                          border: "1px solid #b2dfdb",

                          "&:hover": {
                            backgroundColor: isAllSessionDatesSelected
                              ? "#eeeeee"
                              : "#b2dfdb",
                          },

                          "&.Mui-disabled": {
                            backgroundColor: "#eeeeee",
                            color: "#aaaaaa",
                            border: "1px solid #dddddd",
                          },
                        }}
                      >
                        <AddIcon fontSize="small" />
                      </IconButton>
                    </Box>

                    {/* ADDED SESSION ROWS */}
                    <Box
                      sx={{
                        maxHeight: "45vh",
                        overflowY: "auto",
                        pr: 1,

                        "&::-webkit-scrollbar": {
                          width: "6px",
                        },
                        "&::-webkit-scrollbar-track": {
                          backgroundColor: "#f1f1f1",
                          borderRadius: "10px",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          backgroundColor: "#c1c1c1",
                          borderRadius: "10px",
                        },
                      }}
                    >
                      {sessionRows.map((row, index) => {
                        const selectedDatesInOtherRows = sessionRows
                          .filter((item) => item.id !== row.id)
                          .map((item) => item.sessionDate)
                          .filter(Boolean);

                        const rowAvailableDates = availableSessionDates.filter(
                          (date) => !selectedDatesInOtherRows.includes(date),
                        );

                        const selectedNewDatesInOtherRows = sessionRows
                          .filter((item) => item.id !== row.id)
                          .map((item) => item.newSessionDate)
                          .filter(Boolean);

                        {/* const sessionDatesToDisable = availableSessionDates; */ }

                        const servicesArray = row.sessionDate
                          ? fetchedSessionData[row.sessionDate] || []
                          : [];

                        const sessionServiceOptions = [];

                        if (Array.isArray(servicesArray)) {
                          servicesArray.forEach((srv, serviceIndex) => {
                            sessionServiceOptions.push({
                              uniqueKey: `${row.sessionDate}-${serviceIndex}`,
                              date: row.sessionDate,
                              service_name: srv.service_name,
                              sub_service_name: srv.sub_service_name,
                              label: `${srv.service_name} (${srv.sub_service_name}) - ${row.sessionDate}`,
                            });
                          });
                        }

                        return (
                          <Box
                            key={row.id}
                            sx={{
                              mt: 1.5,
                              p: 1.5,
                              border: "1px solid #ddd",
                              borderRadius: "8px",
                              backgroundColor: "#fff",
                            }}
                          >
                            {/* ROW HEADER */}
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                mb: 1.5,
                              }}
                            >
                              <Typography
                                variant="caption"
                                sx={{
                                  fontWeight: 600,
                                  color: "#555",
                                }}
                              >
                                Reschedule Session
                              </Typography>

                              <IconButton
                                size="small"
                                onClick={() => removeSessionRow(row.id)}
                                sx={{
                                  color: "#d32f2f",
                                }}
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Box>

                            {/* SESSION DATE + NEW SESSION DATE */}
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 2,
                                width: "100%",
                              }}
                            >
                              {/* SESSION DATE */}
                              <FormControl size="small" sx={{ flex: 1 }}>
                                <InputLabel>
                                  Session Date
                                </InputLabel>

                                <Select
                                  value={row.sessionDate}
                                  onChange={(e) =>
                                    updateSessionRow(
                                      row.id,
                                      "sessionDate",
                                      e.target.value,
                                    )
                                  }
                                  input={<OutlinedInput label="Session Date" />}
                                >
                                  {rowAvailableDates.map((dateStr) => (
                                    <MenuItem
                                      key={dateStr}
                                      value={dateStr}
                                    >
                                      {dateStr}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>

                              {/* NEW SESSION DATE */}
                              <Box sx={{ flex: 1 }}>
                                <DatePicker
                                  value={row.newSessionDate || null}
                                  onChange={(val) =>
                                    updateSessionRow(
                                      row.id,
                                      "newSessionDate",
                                      val ? val.format("YYYY-MM-DD") : "",
                                    )
                                  }
                                  format="YYYY-MM-DD"
                                  calendarPosition="bottom-start"
                                  // mapDays={({ date }) => {
                                  //   const dateStr = date.format("YYYY-MM-DD");

                                  //   // Disable ONLY existing session dates
                                  //   const isExistingDate = availableSessionDates.some(
                                  //     (existingDate) => existingDate.substring(0, 10) === dateStr
                                  //   );

                                  //   if (isExistingDate) {
                                  //     return {
                                  //       disabled: true,
                                  //       style: {
                                  //         color: "#999",
                                  //         backgroundColor: "#eeeeee",
                                  //         cursor: "not-allowed",
                                  //         opacity: 0.7,
                                  //       },
                                  //     };
                                  //   }

                                  //   // Disable only dates already selected in another row
                                  //   const isAlreadySelected =
                                  //     selectedNewDatesInOtherRows.includes(dateStr);

                                  //   if (isAlreadySelected) {
                                  //     return {
                                  //       disabled: true,
                                  //       style: {
                                  //         color: "#fff",
                                  //         backgroundColor: "#4caf50",
                                  //         fontWeight: "700",
                                  //         borderRadius: "50%",
                                  //         cursor: "not-allowed",
                                  //       },
                                  //     };
                                  //   }

                                  //   // Between dates + all other dates are ENABLED
                                  //   return {
                                  //     disabled: false,
                                  //     style: {
                                  //       cursor: "pointer",
                                  //     },
                                  //   };
                                  // }}
                                  mapDays={({ date }) => {
                                    const today = new Date();
                                    today.setHours(0, 0, 0, 0);

                                    const selectedDate = date.toDate();
                                    selectedDate.setHours(0, 0, 0, 0);

                                    // Disable only dates before today
                                    if (selectedDate < today) {
                                      return {
                                        disabled: true,
                                        style: {
                                          color: "#999",
                                          backgroundColor: "#eeeeee",
                                          cursor: "not-allowed",
                                          opacity: 0.7,
                                        },
                                      };
                                    }

                                    // ALL dates from today onwards are enabled
                                    return {
                                      disabled: false,
                                      style: {
                                        cursor: "pointer",
                                      },
                                    };
                                  }}
                                  containerStyle={{
                                    width: "100%",
                                  }}
                                  style={{
                                    width: "100%",
                                  }}
                                  render={(value, openCalendar) => (
                                    <TextField
                                      onClick={openCalendar}
                                      label="New Session Date *"
                                      value={value || ""}
                                      size="small"
                                      fullWidth
                                      placeholder="Select new date"
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                    />
                                  )}
                                />
                              </Box>
                            </Box>

                            {/* SERVICES */}
                            {/* SERVICES */}
                            <Box sx={{ mt: 1.5 }}>
                              {sessionServiceOptions.length > 0 ? (
                                <>
                                  {/* Session Time Toggle */}
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                      mb: 1,
                                    }}
                                  >
                                    <Button
                                      size="small"
                                      variant={
                                        showSessionTime[row.id] ? "contained" : "outlined"
                                      }
                                      onClick={() =>
                                        setShowSessionTime((prev) => ({
                                          ...prev,
                                          [row.id]: !prev[row.id],
                                        }))
                                      }
                                      sx={{
                                        textTransform: "none",
                                        fontSize: "12px",
                                        fontWeight: 600,
                                        minWidth: "auto",
                                        px: 1.5,
                                        py: 0.5,
                                        borderColor: "#347b89",
                                        color: showSessionTime[row.id]
                                          ? "#fff"
                                          : "#347b89",
                                        backgroundColor: showSessionTime[row.id]
                                          ? "#347b89"
                                          : "transparent",
                                        "&:hover": {
                                          borderColor: "#347b89",
                                          backgroundColor: showSessionTime[row.id]
                                            ? "#2a6775"
                                            : "#e8f4f5",
                                        },
                                      }}
                                    >
                                      {showSessionTime[row.id]
                                        ? "Hide Session Time"
                                        : "Add Session Time"}
                                    </Button>
                                  </Box>

                                  {/* Services */}
                                  <Box>
                                    {sessionServiceOptions.map((option, serviceIndex) => {
                                      const timeKey = `${row.id}-${serviceIndex}`;
                                      const serviceTime =
                                        sessionServiceTimes[timeKey] || {};

                                      return (
                                        <Box
                                          key={option.uniqueKey}
                                          sx={{
                                            mb: 1.5,
                                            p: 1,
                                            border: "1px solid #ffe0b2",
                                            borderRadius: "8px",
                                            backgroundColor: "#fffaf4",
                                          }}
                                        >
                                          {/* Service Chip + Time */}
                                          <Box
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: 1,
                                              flexWrap: "wrap",
                                            }}
                                          >
                                            <Chip
                                              label={`${option.service_name} (${option.sub_service_name}) - ${option.date}`}
                                              variant="filled"
                                              sx={{
                                                fontWeight: 500,
                                                backgroundColor: "#FFE0B2",
                                                color: "#E65100",
                                                borderColor: "#FFB74D",
                                                "&:hover": {
                                                  backgroundColor: "#FFE0B2",
                                                },
                                              }}
                                            />

                                            {/* Show selected time in front of chip */}
                                            {showSessionTime[row.id] &&
                                              serviceTime.startTime &&
                                              serviceTime.endTime && (
                                                <Typography
                                                  variant="caption"
                                                  sx={{
                                                    fontWeight: 600,
                                                    color: "#347b89",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  {serviceTime.startTime} -{" "}
                                                  {serviceTime.endTime}
                                                </Typography>
                                              )}
                                          </Box>

                                          {/* Start / End Time */}
                                          {showSessionTime[row.id] && (
                                            <Grid
                                              container
                                              spacing={1}
                                              sx={{ mt: 0.5 }}
                                            >
                                              <Grid item xs={6}>
                                                <TextField
                                                  label="Start Time"
                                                  type="time"
                                                  size="small"
                                                  fullWidth
                                                  value={serviceTime.startTime || ""}
                                                  onChange={(e) =>
                                                    handleSessionTimeChange(
                                                      row.id,
                                                      serviceIndex,
                                                      "startTime",
                                                      e.target.value
                                                    )
                                                  }
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                />
                                              </Grid>

                                              <Grid item xs={6}>
                                                <TextField
                                                  label="End Time"
                                                  type="time"
                                                  size="small"
                                                  fullWidth
                                                  value={serviceTime.endTime || ""}
                                                  onChange={(e) =>
                                                    handleSessionTimeChange(
                                                      row.id,
                                                      serviceIndex,
                                                      "endTime",
                                                      e.target.value
                                                    )
                                                  }
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                />
                                              </Grid>
                                            </Grid>
                                          )}
                                        </Box>
                                      );
                                    })}
                                  </Box>
                                </>
                              ) : (
                                <Typography
                                  variant="caption"
                                  sx={{ color: "#777" }}
                                >
                                  {row.sessionDate
                                    ? "No services available for selected date"
                                    : null}
                                </Typography>
                              )}
                            </Box>
                            {/* <Box sx={{ mt: 1.5 }}>
                              {sessionServiceOptions.length > 0 ? (
                                <>
                                  <Box>
                                    {sessionServiceOptions.map(
                                      (option) => (
                                        <Chip
                                          key={option.uniqueKey}
                                          label={`${option.service_name} (${option.sub_service_name}) - ${option.date}`}
                                          variant="filled"
                                          sx={{
                                            cursor: "default",
                                            fontWeight: 500,
                                            mr: 1,
                                            mb: 1,
                                            backgroundColor: "#FFE0B2",
                                            color: "#E65100",
                                            borderColor: "#FFB74D",

                                            "&:hover": {
                                              backgroundColor: "#FFE0B2",
                                            },
                                          }}
                                        />
                                      ),
                                    )}
                                  </Box>
                                </>
                              ) : (
                                <Typography
                                  variant="caption"
                                  sx={{ color: "#777" }}
                                >
                                  {row.sessionDate
                                    ? "No services available for selected date"
                                    : null}
                                </Typography>
                              )}
                            </Box> */}
                          </Box>
                        );
                      })}
                    </Box>
                  </Box>
                </Grid>
              )}
            </>
          )}
        </Grid>
      </Box>

      {/* STICKY FOOTER BUTTON */}
      {selectedOption && !isLoadingApi && (
        <Box sx={{ pt: 2, borderTop: "1px solid #eee", mt: "auto" }}>
          <Button
            variant="contained"
            fullWidth
            onClick={
              selectedOption === "1" ? handleServiceSubmit : handleSessionSubmit
            }
            sx={{
              backgroundColor: "rgb(52, 123, 137)",
              py: 1.2,
              fontWeight: "bold",
              "&:hover": { backgroundColor: "rgb(42, 103, 117)" },
            }}
          >
            {selectedOption === "1"
              ? "Confirm Service Reschedule"
              : "Allocate"}
          </Button>
        </Box>
      )}

      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity={snackbarSeverity}
          onClose={() => setOpenSnackbar(false)}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default PackageReschedule;
